export default __webpack_public_path__ + "static/media/Gold_60F_x264.ddc5a837.mp4";